exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#myFooter{flex:0 0 auto;-webkit-flex:0 0 auto;background-color:#f7f7f7;padding:50px 0;border-top:1px solid #ddd}#myFooter ul{list-style:none;margin:0;padding:0}#myFooter h5{margin-top:0}.footer-copyright{color:#444;margin-top:10px;padding-bottom:5px;margin-right:20px;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6644a488","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/footer.vue
// module id = 105
// module chunks = 0